import React, { Component } from 'react';
import { Row, Col, Table, Spin, Button, Input, Upload, Icon, Popconfirm, Select } from 'antd';
import { api, app, config } from "../../app";
import utils from "../../utils";
import FormModal from "../../components/FormModal2";

const Option = Select.Option;

class PPeType extends Component {
    constructor (props) {
        super(props);
        this.state = {
            c_loading: true,
            classList: [],
            gradeList: [],
            sel_class1: 0,
            sel_class2: 0,
            update_info: null,
            parent_id: null,
            formObject: {},
            imageUrl: '',
        };
    }

    setData = (data) => app.setStateSync(this, data);

    async componentDidMount () {
        this._isMounted = true;
        await this.ClassList();
        await this.GradeList();
    }

    componentWillUnmount () {
        this._isMounted = false;
    }

    /**
     * 分类集合
     * @returns {Promise<any>}
     * @constructor
     */
    ClassList = async () => {
        await this.setData({ c_loading: true });
        let params = {
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        };
        let { flag, data, msg } = await app.post(api.PpeClassListing, params);
        let state = { c_loading: false };
        if (flag === 1) {
            state.classList = data;
        } else {
            app.alert(msg, 'warn');
        }
        await this.setData(state);
    }

    /**
     * 等级集合
     * @returns {Promise<any>}
     * @constructor
     */
    GradeList = async () => {
        await this.setData({ g_loading: true });
        let params = {
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        };
        let { flag, data, msg } = await app.post(api.PpeClassGrade, params);
        let state = { g_loading: false };
        if (flag === 1) {
            state.gradeList = data;
        } else {
            app.alert(msg, 'warn');
        }
        await this.setData(state);
    }

    /**
     * 删除类型
     */
    handleDeleteType = async (class_id, type) => {
        let params = {
            class_id,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        };
        let { flag, msg } = await app.post(api.PpeClassDel, params);
        if (flag === 1) {
            app.alert('删除成功', 'success');
            await app.sleep(1000);
            await this.ClassList();
            if (type === 1) {
                await this.setData({ sel_class1: 0, sel_class2: 0 });
            }
        } else {
            app.alert(msg, 'warn');
        }
    }

    /**
     * 添加类型
     * @param class_name
     * @param parent_id
     * @param url
     * @returns {Promise<boolean>}
     */
    handleAddType = async (class_name, parent_id, url, ppe_grade_id, remarks) => {
        let params = {
            ppe_grade_id,
            parent_id,
            class_name,
            url,
            remarks,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        };
        let { flag, msg } = await app.post(api.PpeClassAdd, params);
        if (flag === 1) {
            app.alert('添加成功', 'success');
            return true;
        } else {
            app.alert(msg, 'warn');
            return false;
        }
    }

    /**
     * 提交修改
     */
    handleEdit = async (parent_id, class_id, class_name, url, ppe_grade_id, remarks) => {
        let params = {
            class_id,
            parent_id,
            ppe_grade_id,
            class_name,
            url,
            remarks,
            indexno: app.getData('indexno'),
            account: app.getData('account')
        };
        let { flag, msg } = await app.post(api.PpeClassEdit, params);
        if (flag === 1) {
            app.alert('修改成功', 'success');
            return true;
        } else {
            app.alert(msg, 'warn');
            return false;
        }
    }

    /**
     * 提交
     */
    handleSubmit = async ({ class_name, url, ppe_grade_id, remarks }) => {
        if (this.state.submit_loading) return false;
        let { parent_id, update_info, imageUrl } = this.state;
        await this.setData({ submit_loading: true });
        let flag = false;
        if (update_info) {
            flag = await this.handleEdit(parent_id, update_info.id, class_name, imageUrl, ppe_grade_id, remarks);
        } else {
            flag = await this.handleAddType(class_name, parent_id, imageUrl, ppe_grade_id, remarks);
        }
        await this.setData({ submit_loading: false });
        if (flag) {
            await this.handleCloseModal();
            await this.ClassList();
        }
    }

    /**
     * 打开编辑框
     * @param update_info
     * @param parent_id
     * @returns {Promise<void>}
     */
    handleOpenModal = (parent_id, update_info) => {
        let state = { modal_visible: true, parent_id, update_info };
        if (update_info) {
            state.imageUrl = update_info.icon;
        }
        this.setData(state);
    }

    /**
     * 关闭编辑框
     * @param id
     * @returns {Promise<void>}
     */
    handleCloseModal = () => {
        this.setData({ modal_visible: false, parent_id: null, update_info: null, imageUrl: '' });
    }

    normFile = (e) => {
        if (Array.isArray(e)) {
            return e;
        }
        return e && e.fileList;
    }

    /**
     * 上传之前
     * @param file
     * @returns {*}
     */
    beforeUpload = (file) => {
        console.log(file);
        const isLt2M = file.size / 1024 < 200;
        if (!isLt2M) {
            app.alert('图片最大200KB!', 'error');
            return Promise.reject(false);
        }
        return Promise.resolve(true);
    }

    handleChange = ({ file }) => {
        if (file.status === 'uploading') {
            this.setState({ up_loading: true });
            return;
        }
        if (file.status === 'done' && file.response && file.response.flag === 1) {
            this.setState({ imageUrl: file.response.data.url, up_loading: false });
        }
    }

    render () {
        let { classList, sel_class1, sel_class2, c_loading, c_loading2, c_loading3, submit_loading, modal_visible, update_info, up_loading, imageUrl, gradeList, g_loading } = this.state,
            classList2 = classList[sel_class1] || {},
            classList3 = classList2.subclass ? classList2.subclass[sel_class2] : {},
            formItemLayout = {
                labelCol: {
                    xs: { span: 24 },
                    sm: { span: 6 },
                },
                wrapperCol: {
                    xs: { span: 24 },
                    sm: { span: 16 },
                }
            },
            columns = [
                {
                    title: '分类图片',
                    dataIndex: 'icon',
                    key: 'icon',
                    width: '30%',
                    render (src) {
                        return (<span className="c2-img"><img src={config.imgUrl + src} alt="无"/></span>);
                    }
                },
                {
                    title: '分类名称',
                    dataIndex: 'names',
                    key: 'names',
                    width: '40%',
                },
                {
                    title: '操作',
                    dataIndex: 'parentid',
                    key: 'parentid',
                    width: '30%',
                    render: (parentid, record) => {
                        return (<span className="c2-link">
                                  <div className="edit-link i-link"
                                       onClick={() => this.handleOpenModal(parentid, record)}>修改</div>
                                  <Popconfirm placement="top" title="删除分类" okText="确定" cancelText="取消"
                                              onConfirm={() => this.handleDeleteType(record.id)}>
                                                        <div className="del-link i-link">删除</div>
                                                    </Popconfirm>
                            </span>);
                    }
                },
            ];
        return (
            <div className="grade-ppe-type">
                <div className="page-title">技能等级设定</div>
                <div className="page-content">
                    <div className="card1">
                        <div className="c-title">一级分类</div>
                        <Button className="add-btn" onClick={() => this.handleOpenModal(0)}>添加分类</Button>
                        <div className="c-content">
                            {
                                c_loading ?
                                    (<div style={{ textAlign: 'center', height: 100, lineHeight: '100px' }}><Spin/>
                                    </div>) :
                                    classList.map((cla, i) => {
                                        return (
                                            <div className="cc-item"
                                                 style={sel_class1 === i ? { borderColor: "#1890ff" } : {}}
                                                 key={i} onClick={async () => {
                                                if (this.state.sel_class1 === i) return;
                                                await this.setData({ c_loading2: true, c_loading3: true });
                                                await app.sleep(200);
                                                await this.setData({
                                                    c_loading2: false,
                                                    c_loading3: false,
                                                    sel_class1: i,
                                                    sel_class2: 0
                                                })
                                            }}>
                                            <span className="i-img">
                                                <img src={config.imgUrl + cla.icon} alt="无图"/>
                                            </span>
                                                <span className="i-name">{cla.names}</span>
                                                <span>
                                                    <div className="edit-link i-link"
                                                         onClick={() => this.handleOpenModal(0, cla)}>修改</div>
                                                    <Popconfirm placement="left" title="删除分类" okText="确定"
                                                                cancelText="取消"
                                                                onConfirm={() => this.handleDeleteType(cla.id, 1)}>
                                                        <div className="del-link i-link">删除</div>
                                                    </Popconfirm>
                                                </span>
                                            </div>
                                        );
                                    })
                            }
                        </div>
                    </div>
                    {
                        classList && classList.length > 0 ?
                            (
                                <Row className="child-class">
                                    <Col span={11} className="card2">
                                        <div className="c-title">{classList2.names || '二级分类'}</div>
                                        <Button className="add-btn"
                                                onClick={() => this.handleOpenModal(classList2.id)}>添加分类</Button>
                                        <div className="c-content">
                                            <Table columns={columns}
                                                   locale={app.tbLocale(c_loading2)}
                                                   dataSource={utils.addArrayKey(classList2.subclass || [])}
                                                   size="small"
                                                   scroll={{ y: 600 }}
                                                   pagination={false}
                                                   loading={c_loading2}
                                                   onRow={(record, index) => {
                                                       return {
                                                           onClick: async () => {
                                                               if (this.state.sel_class2 === index) return;
                                                               await this.setData({ c_loading3: true });
                                                               await app.sleep(200);
                                                               await this.setData({
                                                                   c_loading3: false,
                                                                   sel_class2: index
                                                               })
                                                           }
                                                       };
                                                   }}
                                            />
                                        </div>
                                    </Col>
                                    {
                                        classList3.id ? (
                                            <Col span={11} offset={2} className="card2">
                                                <div className="c-title">{classList3.names || '三级分类'}</div>
                                                <Button className="add-btn"
                                                        onClick={() => this.handleOpenModal(classList3.id)}>添加分类</Button>
                                                <div className="c-content">
                                                    <Table columns={columns}
                                                           locale={app.tbLocale(c_loading3)}
                                                           dataSource={utils.addArrayKey(classList3.subclass || [])}
                                                           size="small"
                                                           scroll={{ y: 600 }}
                                                           pagination={false}
                                                           loading={c_loading3}
                                                    />
                                                </div>
                                            </Col>
                                        ) : null
                                    }
                                </Row>
                            ) : null
                    }
                    <FormModal
                        modal={{
                            visible: modal_visible,
                            title: update_info ? '修改分类' : '添加分类',
                            onCancel: this.handleCloseModal,
                            okText: "确认",
                            cancelText: "取消",
                            confirmLoading: submit_loading,
                            maskClosable: false,
                            destroyOnClose: true,
                        }}
                        onSubmit={this.handleSubmit}
                        other={<div style={{color: "red"}}>注：级别越大代表等级越高。</div>}
                    >
                        {
                            [
                                {
                                    formItemLayout,
                                    label: "添加图片",
                                    name: "url",
                                    options: {
                                        rules: [{ required: true, message: "请上传图片。" }],
                                        valuePropName: 'fileList',
                                        getValueFromEvent: this.normFile,
                                        initialValue: update_info && update_info.icon ? [{
                                            uid: -1,
                                            name: 'xx.png',
                                            status: 'done',
                                            response: {
                                                data: {
                                                    url: update_info.icon
                                                }
                                            }
                                        }] : []
                                    },
                                    component: (
                                        <Upload action={config.serverUrl + api.ImageUpload}
                                                accept='image/jpeg, image/jpg, image/png'
                                                data={{
                                                    token: app.getData('token'),
                                                    indexno: app.getData('indexno'),
                                                    account: app.getData('account'),
                                                    upload_type: 'ppe_class',
                                                }}
                                                name="image"
                                                onChange={this.handleChange}
                                                beforeUpload={this.beforeUpload}
                                                listType="picture-card"
                                                showUploadList={false}
                                        >
                                            {imageUrl ?
                                                <img src={config.imgUrl + imageUrl} style={{ width: 86, height: 86 }}
                                                     alt=""/> :
                                                (
                                                    <div>
                                                        <Icon type={up_loading ? 'loading' : 'plus'}/>
                                                        <div className="ant-upload-text">上传</div>
                                                    </div>
                                                )}
                                        </Upload>
                                    )
                                },
                                {
                                    formItemLayout,
                                    label: "名称",
                                    name: "class_name",
                                    options: {
                                        rules: [
                                            { required: true, message: '请填写分类名称' },
                                        ], initialValue: (update_info || {}).names
                                    },
                                    component: (
                                        <Input/>
                                    )
                                },
                                {
                                    formItemLayout,
                                    label: "级别",
                                    name: "ppe_grade_id",
                                    options: {
                                        rules: [
                                            { required: true, message: '请选择分类等级' },
                                        ], initialValue: (update_info || {}).ppe_grade_id
                                    },
                                    component: (
                                        <Select notFoundContent={g_loading ? <Spin size="small"/> : "暂无记录"}>
                                            {
                                                gradeList.map((grade, i) => {
                                                    return (
                                                        <Option key={i} value={grade.id}>{grade.grade_name}</Option>
                                                    );
                                                })
                                            }
                                        </Select>
                                    )
                                },
                                {
                                    formItemLayout,
                                    label: "备注",
                                    name: "remarks",
                                    options: {
                                        rules: [
                                            { required: true, message: '请填写备注' },
                                        ], initialValue: (update_info || {}).remarks
                                    },
                                    component: (
                                        <Input.TextArea  autosize={{ minRows: 2, maxRows: 6 }}/>
                                    )
                                },
                            ]
                        }
                    </FormModal>
                </div>
            </div>
        );
    }
}

export default PPeType;



// WEBPACK FOOTER //
// ./src/routes/grade/PPeType.jsx